// src/api/products.js
let AllData = "https://uat-ecom.azurewebsites.net";
let localurl="https://localhost:7095"
// 1️⃣ Fetch all categories
export async function getCategories(compId) {
  const response = await fetch(
    `${AllData}/api/sos/Get_soscategoriesclient?companyId=${compId}`,
  );
  if (!response.ok) throw new Error("Failed to fetch categories");
  const data = await response.json();
  console.log("Categories API Response:", data);
  return data;
}

// 2️⃣ Fetch products by categoryId
export async function getProductsByCategory(categoryId, storeId) {
  const response = await fetch(
    `https://uat-ecom.azurewebsites.net/api/sos/getMainProductsByCategory?categoryId=${categoryId}&storeId=${storeId}`,
  );
  if (!response.ok) throw new Error("Failed to fetch products");
  const data = await response.json();
  console.log(`Products for category ${categoryId}:`, data);
  return data;
}

export const getChildProduct = async (id, storeId) => {
  try {
    const res = await fetch(
      `https://uat-ecom.azurewebsites.net/api/sos/getChildProduct?Id=${id}&storeId=${storeId}`,
    );
    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }
    return await res.json();
  } catch (error) {
    console.error("Error fetching child product:", error);
    return { childProducts: [] };
  }
};

export const SaveSosOrder = async (body) => {
  try {
    const res = await fetch(
      `https://uat-ecom.azurewebsites.net/api/ExeSos/save-order-Exesos`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`, // or use your auth token source
        },
        body: JSON.stringify(body),
      },
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    return await res.json();
  } catch (error) {
    console.error("Error saving SOS order:", error);
    return { savedData: [] };
  }
};

export async function getHomeContent(compId) {
  const response = await fetch(
    `https://uat-ecom.azurewebsites.net/api/Sos/Sos_Home_Content?compId=${compId}`,
  );
  if (!response.ok) throw new Error("Failed to fetch Home_Content");
  const data = await response.json();
  console.log("Home Content API Response:", data);
  return data;
}

export async function getMenuContent(compId) {
  console.log(compId);
  const response = await fetch(
    `https://uat-ecom.azurewebsites.net/api/Sos/Sos_Menu_Content?compId=${compId}`,
  );
  if (!response.ok) throw new Error("Failed to fetch Menu Content");
  const data = await response.json();
  console.log("Menu Content API Response:", data);
  return data;
}

export async function getCatAlign(compId) {
  const response = await fetch(
    `https://uat-ecom.azurewebsites.net/api/Sos/Sos_Cat_Align?compId=${compId}`,
  );
  if (!response.ok) throw new Error("Failed to fetch Content");
  const data = await response.json();
  console.log("API Response:", data);
  return data;
}

export async function getOrderTypeContent(compId) {
  const response = await fetch(
    `https://uat-ecom.azurewebsites.net/api/Sos/Sos_OrderType_Content?compId=${compId}`,
  );
  if (!response.ok) throw new Error("Failed to fetch Home_Content");
  const data = await response.json();
  console.log("OrderType Content API Response:", data);
  return data;
}

// getmac

// export async function getmacAdrs(MacId) {
//   const response = await fetch(
//     `https://uat-ecom.azurewebsites.net/api/sos/Get_Mac_add?MacAddress=${MacId}`,
//   );
//   if (!response.ok) throw new Error("Failed to fetch products");
//   const data = await response.json();
//   // console.log(`Products for category ${categoryId}:`, data);
//   return data;
// }

export async function getmacAdrs(MacId) {
  const response = await fetch(
    "https://uat-ecom.azurewebsites.net/api/sos/Get_Mac_add?MacAddress=60:cf:84:7a:e8:34",
  );
  if (!response.ok) throw new Error("Failed to fetch products");
  const data = await response.json();
  // console.log(`Products for category ${categoryId}:`, data);
  return data;
}

export const getchildaddons = async (id) => {
  try {
    const res = await fetch(
      `https://uat-ecom.azurewebsites.net/api/sos/Get_Sos_Addons?childProdId=${id}`,
    );
    return await res.json();
  } catch (error) {
    console.error("Error fetching child product addons:", error);
    return { childProductsAddons: [] };
  }
};

export const getorderno = async (id) => {
  try {
    const res = await fetch(
      `https://uat-ecom.azurewebsites.net/api/Sos/GetOrderNo?StoreId=${id}`,
    );
    return await res.json();
  } catch (error) {
    console.error("Error fetching orderno:", error);
    return { Orderno: [] };
  }
};

export const createQr = async (amount, orderId) => {
  try {
    const res = await fetch(
      `https://uat-ecom.azurewebsites.net/api/BizPayment/create-qr-simple`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Amount: amount,
          OrderId: orderId,
        }),
      },
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    return await res.json();
  } catch (error) {
    console.error("Error creating QR code:", error);
    return { success: false, message: error.message };
  }
};

export const getqrdetails = async (qrId) => {
  try {
    const res = await fetch(
      `https://uat-ecom.azurewebsites.net/api/BizPayment/qr-details-by-id?qrId=${qrId}`,
    );
    return await res.json();
  } catch (error) {
    console.error("Error fetching child product addons:", error);
    return { QrDetails: [] };
  }
};

export const saveCustomer = async (mobile, sid, cid) => {
  try {
    const res = await fetch(
      `https://uat-ecom.azurewebsites.net/api/Sos/Sos_cust_no?mobile=${mobile}&sid=${sid}&cid=${5}`,
    );

    if (!res.ok) throw new Error("Failed to save customer");
    return await res.json();
  } catch (error) {
    console.error("Error saving customer:", error);
    return { status: 500, msg: "Network or API Error", custid: 0 };
  }
};

// GET alldata in to store in localdb

export const getalldata = async (companyId, storeId, typeId) => {
  try {
    const res = await fetch(
      `https://uat-ecom.azurewebsites.net/api/Sos/getalldatafbworld-urapakkam?companyId=${companyId}&storeId=${storeId}&typeId=${typeId}`,
    );

    if (!res.ok) throw new Error("Failed to save all data");
    return await res.json();
  } catch (error) {
    console.error("Error saving all data:", error);
    return { status: 500, msg: "Network or API Error" };
  }
};

// save data in localdb

export const savelocaldata = async (data) => {
  try {
    const res = await fetch(`http://192.168.88.33:1111/addstoredata`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        prodTimeData: data.prodTime || [],
        products: data.products || [],
        categories: data.categories || [],
        addons: data.addons || [],
        recomendedProd: data.recomendedProd || [],
      }),
    });

    return await res.json();
  } catch (error) {
    console.error("Error saving local data:", error);
    return { error: true, message: error.message };
  }
};

export async function getlocalcategories() {
  const response = await fetch(`http://192.168.88.33:1111/categories`);
  if (!response.ok) throw new Error("Failed to fetch Category");
  const data = await response.json();
  console.log("Category Content API Response:", data);
  return data;
}

export async function getlocalrecprod() {
  const response = await fetch(`http://192.168.88.33:1111/recommendedProds`);
  if (!response.ok) throw new Error("Failed to fetch recommendedProds");
  const data = await response.json();
  console.log("recommendedProds Content API Response:", data);
  return data;
}

export async function getlocalprodbycatid(catid) {
  const response = await fetch(
    `http://192.168.88.33:1111/getcatidbyproduct/${catid}`,
  );
  if (!response.ok) throw new Error("Failed to fetch Products");
  const data = await response.json();
  // console.log("Products Content API Response:", data);
  return data;
}
// Add this function to service.js - LIVE API version of getlocalchildbyproduct
export const getChildProductLive = async (productId, storeId) => {
  try {
    const res = await fetch(
      `https://uat-ecom.azurewebsites.net/api/sos/getChildProduct?Id=${productId}&storeId=${storeId}`
    );
    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }
    const data = await res.json();
    return {
      childProducts: data.childProducts || [],
      addons: data.addons || []
    };
  } catch (error) {
    console.error("Error fetching child product:", error);
    return { childProducts: [], addons: [] };
  }
};
export async function getlocalchildbyproduct(id) {
  const response = await fetch(`http://192.168.88.33:1111/getparentbyChild/${id}`);
  if (!response.ok) throw new Error("Failed to fetch ChildProduct");
  const data = await response.json();
  // console.log("ChildProduct Content API Response:", data);
  return data;
}
export async function getlocalcompany() {
  const response = await fetch(`http://localhost:2025/company`);
  if (!response.ok) throw new Error("Failed to fetch Company");
  const data = await response.json();
  console.log("Company Content API Response:", data);
  return data;
}

export const getdata = async (companyId, storeId) => {
  try {
    const res = await fetch(
      `https://uat-ecom.azurewebsites.net/api/Sos/getData?companyId=${companyId}&storeId=${storeId}`,
    );

    if (!res.ok) throw new Error("Failed to save all data");
    return await res.json();
  } catch (error) {
    console.error("Error saving all data:", error);
    return { status: 500, msg: "Network or API Error" };
  }
};

export const deleteAllRows = async () => {
  try {
    const res = await fetch(`http://192.168.88.33:1111/delete-all-tables`, {
      method: "DELETE",
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    return await res.json();
  } catch (error) {
    console.error("Error deleting rows:", error);
    return { Status: 500, message: "Error deleting rows" };
  }
};

export async function getLogoContent(compId) {
  const response = await fetch(
    `https://uat-ecom.azurewebsites.net/api/Sos/Sos_logo_Content?compId=${compId}`,
  );
  if (!response.ok) throw new Error("Failed to fetch LogoImage");
  const data = await response.json();
  console.log("LogoImage Content API Response:", data);
  return data;
}

export const getfreeprod = async (companyId, storeId) => {
  try {
    const res = await fetch(
      `https://uat-ecom.azurewebsites.net/api/Sos/getFreeProd?companyId=${companyId}&storeId=${storeId}`,
    );

    if (!res.ok) throw new Error("Failed to save all data");
    return await res.json();
  } catch (error) {
    console.error("Error saving all data:", error);
    return { status: 500, msg: "Network or API Error" };
  }
};


export const getStoreSeries = async (storeId) => {
  const res = await fetch(`https://uat-ecom.azurewebsites.net/api/Sos/get-store-series/${storeId}`);
  return await res.json();
};
const BACKEND = "http://192.168.88.33:5000";
function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

// ── Open or download invoice PDF ─────────────────────────────────────────
// Enhanced downloadReceipt function with better handling

// Enhanced downloadReceipt function with table number support

export async function downloadReceipt(tracking, storeName, logoUrl, customerDetails = {}) {
  try {
    const apiUrl = `${BACKEND}/api/Landingpage/generate-invoice`;
    
    const params = new URLSearchParams({
      invoiceNo: tracking.invoiceNo || '',
      orderNo: tracking.orderNo || '',
      total: tracking.total?.toString() || '0',
      orderType: tracking.orderType || 'Take Away',
      paymentType: tracking.paymentType || 'Pay at Counter',
      storeName: storeName || 'Restaurant',
      logoUrl: logoUrl || '',
      placedAt: tracking.placedAt?.toString() || Date.now().toString(),
      itemsJson: JSON.stringify(tracking.items || []),
      customerName: customerDetails.name || 'Guest',
      customerPhone: customerDetails.phone || '',
      tableNumber: localStorage.getItem('tableNumber') || '',
      storeAddress: localStorage.getItem('storeAddress') || '',
      gstNumber: localStorage.getItem('gstNumber') || ''
    });

    const response = await fetch(`${apiUrl}?${params.toString()}`, {
      method: "GET",
      headers: {
        "Accept": "application/pdf",
      },
    });

    if (!response.ok) throw new Error("PDF generation failed");

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    if (isMobile) {
      const link = document.createElement("a");
      link.href = url;
      link.download = `receipt-${tracking.orderNo}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      if (window.showToast) {
        window.showToast('Receipt downloaded!', 'success');
      }
      
      setTimeout(() => window.URL.revokeObjectURL(url), 2000);
    } else {
      window.open(url, "_blank");
      setTimeout(() => window.URL.revokeObjectURL(url), 5000);
    }
    
    return true;
  } catch (error) {
    console.error("Receipt download error:", error);
    if (window.showToast) {
      window.showToast('Failed to download receipt', 'error');
    }
    return false;
  }
}

// Helper function for notifications
function showNotification(message, type = 'info') {
  // You can implement this with your preferred toast/notification system
  if (window.showToast) {
    window.showToast(message, type);
  } else {
    alert(message);
  }
}


export async function getStoreStatus(storeId) {
  const res = await fetch(`https://uat-ecom.azurewebsites.net/api/Sos/store-status?storeId=${storeId}`);
  if (!res.ok) throw new Error("Could not check store status");
  return res.json(); // { isMaintenance: true/false }
}


